
import { CustomerState } from './../customer/customer.reducer';
import { updateCoins } from './../customer/customer.actions';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as CoinTransactionActions from './coin-transaction.actions';
import CoinTransactionService from '../../services/CoinTransactionService';
import { mergeMap, map, tap, catchError, of } from 'rxjs';
import { CoinTransaction } from '../../models/CoinTransaction';
import CustomerService from '../../services/CustomerService';
import { Store } from '@ngrx/store';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable()
export class CoinTransactionEffects {
  getCoinTransactions$;
  getCoinTransactionsByCustomerNo$;
  getMyCoinTransactions$;
  addCoinTransaction$;

  constructor(
    private actions$: Actions,
    private service: CoinTransactionService,
    private customerStore: Store<{ customer: CustomerState }>,
    private snackBar: MatSnackBar
  ) {
    this.getCoinTransactions$ = createEffect(() =>
      this.actions$.pipe(
        ofType(CoinTransactionActions.getCoinTransactions),
        mergeMap(() =>
          this.service.getCoinTransactions().pipe(
            map((coinTransactions: CoinTransaction[]) =>
              CoinTransactionActions.getCoinTransactionsSuccess({
                coinTransactions,
              })
            )
          )
        )
      )
    );

    this.getCoinTransactionsByCustomerNo$ = createEffect(() =>
      this.actions$.pipe(
        ofType(CoinTransactionActions.getCoinTransactionsByCustomerNo),
        mergeMap(({ customerNo }) =>
          this.service.getCoinTransactionsByCustomerNo(customerNo).pipe(
            map((coinTransactions: CoinTransaction[]) =>
              CoinTransactionActions.getCoinTransactionsByCustomerNoSuccess({
                coinTransactions,
              })
            )
          )
        )
      )
    );

    this.getMyCoinTransactions$ = createEffect(() =>
      this.actions$.pipe(
        ofType(CoinTransactionActions.getMyCoinTransactions),
        mergeMap(() =>
          this.service.getMyCoinTransactions().pipe(
            map((coinTransactions: CoinTransaction[]) =>
              CoinTransactionActions.getMyCoinTransactionsSuccess({
                coinTransactions,
              })
            )
          )
        )
      )
    );

    this.addCoinTransaction$ = createEffect(() =>
      this.actions$.pipe(
        ofType(CoinTransactionActions.addCoinTransaction),
        mergeMap(({ coinTransaction }) =>
          this.service.addCoinTransaction(coinTransaction).pipe(
            map((result: CoinTransaction) => CoinTransactionActions.addCoinTransactionSuccess({ coinTransaction: result })),
            tap(() => this.snackBar.open('Coin-Transaktion hinzugefügt.', 'Schließen', { duration: 2500 })),
            catchError((error) => {
              this.snackBar.open('Fehler beim Hinzufügen der Coin-Transaktion.', 'Schließen', { duration: 2500 });
              return of(CoinTransactionActions.addCoinTransactionFailure({ error }));
            })
          )
        )
      )
    );
  }
}
